import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const useSendEmail = () => {
  const queryClient = useQueryClient();
  return useMutation(
    params => {
      return axios.put(`${apiSitePrefix}/emailmanager/sendRequest`, params.record)
    },
    {
      onMutate: async (record) => {
        const previousData = record.record;
        const options = { previousData, key: [] };
        return options;
      },
      onSuccess: (rec, variables, options) => {
        const { key } = options;
        if (variables.resolve) variables.resolve(rec);
        if (variables.postSuccess) variables.postSuccess({ key, record: rec, status: "SUCCESS" });
      },
      onError: (err, variables, options) => {
        const { key, previousData } = options;
        if (variables.reject) variables.reject(err);
        if (variables.postError) variables.postError({ key, status: "ERROR", errorMessage: err?.response?.data?.errorMessage });
      }
    }
  )
};

export default useSendEmail;
